import { render } from "./CIS-List-Landing-Link.vue?vue&type=template&id=6d70206e&scoped=true"
import script from "./CIS-List-Landing-Link.vue?vue&type=script&lang=js"
export * from "./CIS-List-Landing-Link.vue?vue&type=script&lang=js"

import "./CIS-List-Landing-Link.vue?vue&type=style&index=0&id=6d70206e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d70206e"]])

export default __exports__